module.exports = __webpack_public_path__ + "img/logoNovaccess.670bf8b7.svg";